import { render, staticRenderFns } from "./Comp1.vue?vue&type=template&id=6307842e&scoped=true&"
import script from "./Comp1.vue?vue&type=script&lang=js&"
export * from "./Comp1.vue?vue&type=script&lang=js&"
import style0 from "./Comp1.vue?vue&type=style&index=0&id=6307842e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6307842e",
  null
  
)

export default component.exports